import { Observable } from 'rxjs'
import { MbDatasetEntry, MbProductTabApplications } from '../../../models'

export abstract class MbProductTabApplicationsAdapter {

  abstract load<T extends MbDatasetEntry>(productCode: string, maxCount?: number): Observable<MbProductTabApplications[]>
}
